import React from 'react';
import { Card, Divider } from '@mui/material';
import T from 'prop-types';
import {
  IrisBatchDetailsPropTypes,
  IrisBatchLimitsPropTypes,
  IrisBatchStatusPropTypes,
  IrisBatchTargetPropTypes
} from '../../../../../helpers/propTypes';
import IrisBatchDetails from './IrisBatchBlocks/IrisBatchDetails';
import IrisBatchStatus from './IrisBatchBlocks/IrisBatchStatus';
import IrisBatchTarget from './IrisBatchBlocks/IrisBatchTarget';
import IrisBatchLimits from './IrisBatchBlocks/IrisBatchLimits';
import { PlcType } from '../../../../../attrs/plcConfigValues';
import IrisBatchTargetPLC from './IrisBatchBlocks/IrisBatchTargetPLC';

const IrisBatch = ({ details, status, target, limits, machineId, plcType }) => {
  if (plcType.plc_type === PlcType.IRIS_V3) {
    return (
      <Card sx={{ p: 4, my: 2 }}>
        <IrisBatchDetails
          details={details}
          status={status}
          target={target}
          limits={limits}
          machineId={machineId}
          plcType={plcType}
        />
        <Divider orientation="horizontal" flexItem sx={{ m: 0.5 }} />
        <IrisBatchStatus
          details={details}
          status={status}
          target={target}
          limits={limits}
          machineId={machineId}
          plcType={plcType}
        />
        <Divider orientation="horizontal" flexItem sx={{ m: 0.5 }} />
        <IrisBatchTarget
          details={details}
          status={status}
          target={target}
          limits={limits}
          machineId={machineId}
          plcType={plcType}
        />
        <Divider orientation="horizontal" flexItem sx={{ m: 0.5 }} />
        <IrisBatchLimits
          details={details}
          status={status}
          target={target}
          limits={limits}
          machineId={machineId}
          plcType={plcType}
        />
      </Card>
    );
  } else {
    return (
      <>
        <Card sx={{ p: 4, my: 2 }}>
          <IrisBatchDetails
            details={details}
            status={status}
            target={target}
            limits={limits}
            machineId={machineId}
            plcType={plcType}
          />
        </Card>
        <Card sx={{ p: 4, my: 2 }}>
          <IrisBatchStatus
            details={details}
            status={status}
            target={target}
            limits={limits}
            machineId={machineId}
            plcType={plcType}
          />
        </Card>
        <Card sx={{ p: 4, my: 2 }}>
          {plcType.plc_type === PlcType.IRIS_V3 ? (
            <IrisBatchTarget
              details={details}
              status={status}
              target={target}
              limits={limits}
              machineId={machineId}
              plcType={plcType}
            />
          ) : (
            <IrisBatchTargetPLC
              details={details}
              status={status}
              target={target}
              limits={limits}
              machineId={machineId}
              plcType={plcType}
            />
          )}
        </Card>
        <Card sx={{ p: 4, my: 2 }}>
          <IrisBatchLimits
            details={details}
            status={status}
            target={target}
            limits={limits}
            machineId={machineId}
            plcType={plcType}
          />
        </Card>
      </>
    );
  }
};

IrisBatch.propTypes = {
  details: IrisBatchDetailsPropTypes,
  status: IrisBatchStatusPropTypes,
  target: IrisBatchTargetPropTypes,
  limits: IrisBatchLimitsPropTypes,
  machineId: T.string.isRequired,
  plcType: T.shape({
    plc_type: T.string,
    autoconfig_enabled: T.bool
  }).isRequired
};

IrisBatch.defaultProps = {
  details: null,
  status: null,
  target: null,
  limits: null
};

export default IrisBatch;
